import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-success-signup',
  templateUrl: './success-signup.component.html',
  styleUrls: ['./success-signup.component.css']
})
export class SuccessSignupComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/components/login-signup/success-signup/success-signup.component.ts